import {
    flexRender,
    Row as ReactTableRow,
    RowData,
} from "@tanstack/react-table";

import { Cell } from "../../Table/Cell";
import { Row } from "../../Table/Row";

import { tstColumnWidth } from "./columnMeta";

interface TSTRowProps<T> {
    row: ReactTableRow<T>;
}

export function TSTRow<T extends RowData>({ row }: TSTRowProps<T>) {
    return (
        <Row selected={row.getIsSelected()}>
            {row.getVisibleCells().map((cell) => {
                const isLeftPinned = cell.column.getIsPinned() === "left";
                return (
                    <Cell
                        key={cell.id}
                        sorted={cell.column.getIsSorted() !== false}
                        width={tstColumnWidth(
                            cell.column,
                            cell.getContext().table
                        )}
                        pinned={isLeftPinned}
                        left={
                            isLeftPinned
                                ? cell.column.getStart("left")
                                : undefined
                        }
                    >
                        {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                        )}
                    </Cell>
                );
            })}
        </Row>
    );
}
